import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Hydraulique from "./pages/Hydraulique";
import Oxycoupage from "./pages/Oxycoupage";
import RechercheEtDeveloppement from "./pages/R&D";
import About from "./pages/About";
import Machines from "./pages/Machines";
import Histoire from "./pages/Histoire";
import MachineDetails from "./pages/MachineDetails";
import NewsDetails from "./pages/NewsDetails";
import BackToTopButton from "./components/BackToTopButton";
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import PrivateRoute from "./components/PrivateRoute";
import NotFound from "./pages/NotFound";
import MachineManagement from "./pages/admin/MachineManagement";
import MachineManagementDetails from "./pages/admin/MachineManagementDetails";
import CategoryManagement from "./pages/admin/CategoryManagement";
import NewsManagement from "./pages/admin/NewsManagement";
import NewsManagementDetails from "./pages/admin/NewsManagementDetails";
import Realisations from "./pages/Realisations";

const App = () => {
  const location = useLocation();
  let lang =
    localStorage.getItem("language") || navigator.language.slice(0, 2) || "en";

  if (!["en", "fr", "es", "it", "de"].includes(lang)) {
    lang = "en";
  }

  document.documentElement.lang = lang;

  const url_with_lang = () => {
    return "/" + lang + location.pathname;
  };

  ["/en", "/fr", "/es", "/it", "/de"].forEach((path) => {
    if (location.pathname.startsWith(path) && lang !== path.slice(1)) {
      localStorage.setItem("language", path.slice(1));
      fetch("/api/language", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ language: path.slice(1) }),
      });
    }
  });

  return (
    <div className="text-center">
      <Header />
      <main>
        <ScrollToTop />
        <Routes>
          {/* Default Route */}
          <Route path="/" element={<Navigate to={"/" + lang} />} />
          <Route path="/contact" element={<Navigate to={url_with_lang()} />} />
          <Route
            path="/hydraulique"
            element={<Navigate to={url_with_lang()} />}
          />
          <Route
            path="/oxycoupage"
            element={<Navigate to={url_with_lang()} />}
          />
          <Route path="/r&d" element={<Navigate to={url_with_lang()} />} />
          <Route path="/a-propos" element={<Navigate to={url_with_lang()} />} />
          <Route
            path="/nos-machines"
            element={<Navigate to={url_with_lang()} />}
          />
          <Route
            path="/notre-histoire"
            element={<Navigate to={url_with_lang()} />}
          />
          <Route
            path="/machine/:id"
            element={<Navigate to={url_with_lang()} />}
          />
          <Route
            path="/actualites/:id"
            element={<Navigate to={url_with_lang()} />}
          />
          <Route
            path="/nos-realisations"
            element={<Navigate to={url_with_lang()} />}
          />

          {/* English Routes */}
          <Route path="/en" element={<Home />} />
          <Route path="/en/contact" element={<Contact />} />
          <Route path="/en/hydraulique" element={<Hydraulique />} />
          <Route path="/en/oxycoupage" element={<Oxycoupage />} />
          <Route path="/en/r&d" element={<RechercheEtDeveloppement />} />
          <Route path="/en/a-propos" element={<About />} />
          <Route path="/en/nos-machines" element={<Machines />} />
          <Route path="/en/notre-histoire" element={<Histoire />} />
          <Route path="/en/machine/:id" element={<MachineDetails />} />
          <Route path="/en/actualites/:id" element={<NewsDetails />} />
          <Route path="/en/nos-realisations" element={<Realisations />} />

          {/* French Routes */}
          <Route path="/fr" element={<Home />} />
          <Route path="/fr/contact" element={<Contact />} />
          <Route path="/fr/hydraulique" element={<Hydraulique />} />
          <Route path="/fr/oxycoupage" element={<Oxycoupage />} />
          <Route path="/fr/r&d" element={<RechercheEtDeveloppement />} />
          <Route path="/fr/a-propos" element={<About />} />
          <Route path="/fr/nos-machines" element={<Machines />} />
          <Route path="/fr/notre-histoire" element={<Histoire />} />
          <Route path="/fr/machine/:id" element={<MachineDetails />} />
          <Route path="/fr/actualites/:id" element={<NewsDetails />} />
          <Route path="/fr/nos-realisations" element={<Realisations />} />

          {/* Spanish Routes */}
          <Route path="/es" element={<Home />} />
          <Route path="/es/contact" element={<Contact />} />
          <Route path="/es/hydraulique" element={<Hydraulique />} />
          <Route path="/es/oxycoupage" element={<Oxycoupage />} />
          <Route path="/es/r&d" element={<RechercheEtDeveloppement />} />
          <Route path="/es/a-propos" element={<About />} />
          <Route path="/es/nos-machines" element={<Machines />} />
          <Route path="/es/notre-histoire" element={<Histoire />} />
          <Route path="/es/machine/:id" element={<MachineDetails />} />
          <Route path="/es/actualites/:id" element={<NewsDetails />} />
          <Route path="/es/nos-realisations" element={<Realisations />} />

          {/* Italian Routes */}
          <Route path="/it" element={<Home />} />
          <Route path="/it/contact" element={<Contact />} />
          <Route path="/it/hydraulique" element={<Hydraulique />} />
          <Route path="/it/oxycoupage" element={<Oxycoupage />} />
          <Route path="/it/r&d" element={<RechercheEtDeveloppement />} />
          <Route path="/it/a-propos" element={<About />} />
          <Route path="/it/nos-machines" element={<Machines />} />
          <Route path="/it/notre-histoire" element={<Histoire />} />
          <Route path="/it/machine/:id" element={<MachineDetails />} />
          <Route path="/it/actualites/:id" element={<NewsDetails />} />
          <Route path="/it/nos-realisations" element={<Realisations />} />

          {/* German Routes */}
          <Route path="/de" element={<Home />} />
          <Route path="/de/contact" element={<Contact />} />
          <Route path="/de/hydraulique" element={<Hydraulique />} />
          <Route path="/de/oxycoupage" element={<Oxycoupage />} />
          <Route path="/de/r&d" element={<RechercheEtDeveloppement />} />
          <Route path="/de/a-propos" element={<About />} />
          <Route path="/de/nos-machines" element={<Machines />} />
          <Route path="/de/notre-histoire" element={<Histoire />} />
          <Route path="/de/machine/:id" element={<MachineDetails />} />
          <Route path="/de/actualites/:id" element={<NewsDetails />} />
          <Route path="/de/nos-realisations" element={<Realisations />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<Login />} />
          <Route
            path="/admin/dashboard"
            element={<PrivateRoute element={<Dashboard />} />}
          />
          <Route
            path="/admin/machine"
            element={<PrivateRoute element={<MachineManagement />} />}
          />
          <Route
            path="/admin/machine/:id"
            element={<PrivateRoute element={<MachineManagementDetails />} />}
          />
          <Route
            path="/admin/category"
            element={<PrivateRoute element={<CategoryManagement />} />}
          />
          <Route
            path="/admin/news"
            element={<PrivateRoute element={<NewsManagement />} />}
          />
          <Route
            path="/admin/news/:id"
            element={<PrivateRoute element={<NewsManagementDetails />} />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <BackToTopButton />
      </main>
      <Footer />
    </div>
  );
};

// Wrap App in Router for useLocation to work
const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
